/* This file was generated by running "node scripts/generateTranslations.js". */
/* Created: 2026-09-10 13:57:07 */

const Keys = { bookedItemComponent: 'bookedItemComponent' }; export default Keys;